(function () {
    'use strict';

    var module = angular.module('uwAgenda.search');
    module.directive('searchItem', ['AppointmentDetailService', 'EmailService', 'TaskService', 'UserService', 'SharedAgendaService', SearchItemFn]);

    /* directive for search item in search-result */
    function SearchItemFn(AppointmentDetailService, EmailService, TaskService, UserService, SharedAgendaService) {

        var directive = {
            restrict: 'E',
            templateUrl: '/app/search/templates/search-item.template.html',
            scope: {
                item: '=',
                searchStr: '='
            },
            link: link
        };
        return directive;

        function link(scope) {

            // open search result - depending on type
            scope.open = function () {
                // open selected
                switch (scope.item.searchResultType) {
                    case 0:
                        openAppointment(scope.item.id);
                        break;
                    case 1:
                        openMessage(scope.item.id);
                        break;
                    case 2:
                        openTask(scope.item.relatedId);
                        break;
                    case 3:
                        openUser(scope.item.relatedId);
                        break;
                }
            };

            // open Appointment
            function openAppointment(id) {
                AppointmentDetailService.show(id);
            }

            // open Message
            function openMessage(id) {
                EmailService.show(id);
            }

            // open Task
            function openTask(id) {
                TaskService.show(id);
            }

            // open User
            function openUser(id) {
                UserService.show(id, SharedAgendaService.currentUser().id, SharedAgendaService.data.currentAgenda.id);
            }
        }
    }
})();